import { TableCellProps } from '@chakra-ui/table';
import React from 'react';

import { CmTd } from '@/components/uiParts';

export const CmFixedTd: React.FC<TableCellProps> = ({ ...rest }) => {
  return (
    <CmTd
      textAlign="center"
      position="sticky"
      zIndex="1"
      bgColor="white"
      {...rest}
    />
  );
};
